import { resolveBackendUrl } from './apiConfig'

export const getImageUrl = (url) => {
    if (!url) return null;
    if (url.startsWith('http')) return url;

    return resolveBackendUrl(url);
};
